import _ from "underscore";

const isLegalGroup = (selectionGroup) => {
    if (selectionGroup.length === 0) {
        return false;
    }

    return true;
};

export { isLegalGroup };
